import React, { useEffect } from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiGridForm from "../components/Form/UiGridForm";
import UiInputList from "../components/Form/UiInputList";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputNumber from "../components/Form/UiInputNumber";
import UiInputTextarea from "../components/Form/UiInputTextarea";
import UiInputMoney from "../components/Form/UiInputMoney";
import {getExtruturaList} from "../services/ApiService";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";

export default function KitForm(props: any){

    let defaultValues = props.data;
    if(!defaultValues){
        defaultValues = {
            //dataFechamento: dayjs().format('YYYY-MM-DD')
        }
    }

    const methods = useForm({
        defaultValues: defaultValues
    });
    const { register, handleSubmit, watch, setValue, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const tipoList = [
        { id: 1, title: 'Ongrid' },
        { id: 2, title: 'Offgrid' },
        { id: 3, title: 'Hibrido' },
    ];

    const ligacaoList = [
        { id: 1, title: 'Monofasico' },
        { id: 2, title: 'Bifasico' },
        { id: 3, title: 'Trifasico' },
    ];
    const onSelectOrcamento = (data: any) => {
        if(data){
            if(!allData.precoVenda || allData.precoVenda == '' || allData.precoVenda < 1){
                setValue('precoVenda', data.kit_preco_venda);
                setValue('precoEquipamentos', data.kit_preco);
                setValue('precoMaoObra', data.kit_preco_venda - data.kit_preco);
                setValue('geracaoGarantida', data.geracao_garantida);
            }
        }
    }

    const baseEstruturaList: any = getExtruturaList();
    const estruturaList = Object.keys(baseEstruturaList).map((key) => {
        return { id: key, title: baseEstruturaList[key] };
    })

    const allData = watch();
    const produtoList = watch('produtoList');
    const fornecedor = watch('fornecedor');
    const tipo = watch('tipo');

    // Função para detectar automaticamente os dados do kit
    const detectarAutomaticamente = () => {
        const produtos = produtoList || [];

        console.log('Detectando automaticamente...', produtos);

        // Dados extraídos para gerar referência
        let dadosReferencia: any = {
            fornecedor: '',
            inversorPotenciaUnitaria: 0,
            inversorQuantidade: 0,
            inversorPotenciaTotal: 0,
            ligacao: '',
            inversorMarca: '',
            placas: '',
            tipoPainel: '',
            marcaPainel: '',

            cabos: false,
        };

        // Extrai primeira palavra do fornecedor (ex: "ATINOS COMERCIO..." → "ATINOS")
        if (fornecedor?.razaoSocial) {
            dadosReferencia.fornecedor = fornecedor.razaoSocial.split(' ')[0].toUpperCase();
        }

        // Parser de Painéis Solares
        const painel = produtos.find((p: any) => {
            const nome = p?.produto?.nome || '';
            console.log('Testando produto:', { p, nome, match: /PAINEL|MODULO|PLACA/i.test(nome) });
            return /PAINEL|MODULO|PLACA/i.test(nome);
        });

        console.log('Painel encontrado:', painel);

        if (painel && painel.produto?.nome) {
            const nomePainel = painel.produto.nome;

            // Extrai potência (ex: "625W", "550W")
            const potenciaMatch = nomePainel.match(/(\d+\.?\d*)\s*W/i);
            console.log('Potência match:', potenciaMatch);

            if (potenciaMatch) {
                const potencia = parseFloat(potenciaMatch[1]);
                const quantidade = parseInt(painel.quantidade);

                console.log('Preenchendo:', { quantidade, potencia });

                // Só preenche se valores válidos (não zero, não NaN)
                if (quantidade && !isNaN(quantidade)) {
                    setValue('numeroPlacas', quantidade);

                    // Calcula peso: 25kg por placa
                    const pesoCalculado = quantidade * 25;
                    setValue('peso', pesoCalculado);

                    // Calcula área: 2,5m² por placa
                    const areaCalculada = quantidade * 2.5;
                    setValue('area', parseFloat(areaCalculada.toFixed(2)));
                }
                if (potencia && !isNaN(potencia)) {
                    setValue('potenciaPlacas', potencia);
                    setValue('imagem', `${process.env.REACT_APP_API_ENDPOINT}/assets/${Math.round(potencia)}W.png`);
                }

                // Calcula kWp automaticamente
                if (quantidade > 0 && potencia > 0) {
                    const kwpCalculado = (quantidade * potencia) / 1000;
                    setValue('kwp', parseFloat(kwpCalculado.toFixed(2)));
                    dadosReferencia.placas = `${quantidade}x${Math.round(potencia)}W`;
                }
            }

            // Extrai tipo do painel (MONOFACIAL, BIFACIAL)
            if (/MONOFACIAL/i.test(nomePainel)) {
                dadosReferencia.tipoPainel = 'MONOFACIAL';
            } else if (/BIFACIAL/i.test(nomePainel)) {
                dadosReferencia.tipoPainel = 'BIFACIAL';
            }

            // Extrai marca do painel (procura palavra após MONOFACIAL/BIFACIAL)
            const marcaPainelMatch = nomePainel.match(/(?:MONO|BI)FACIAL\s+(\w+)/i);
            if (marcaPainelMatch) {
                dadosReferencia.marcaPainel = marcaPainelMatch[1].toUpperCase();
            }

            // Extrai tipo especial do painel (N-TYPE, P-TYPE, etc)
            const tipoEspecialMatch = nomePainel.match(/\b(N-TYPE|P-TYPE|PERC|HALF-CELL)\b/i);
            if (tipoEspecialMatch) {
                // Adiciona ao marcaPainel separado por espaço
                dadosReferencia.marcaPainel = dadosReferencia.marcaPainel
                    ? `${dadosReferencia.marcaPainel}-${tipoEspecialMatch[1].toUpperCase()}`
                    : tipoEspecialMatch[1].toUpperCase();
            }
        }

        // Parser de Inversor
        const inversor = produtos.find((p: any) => {
            const nome = p?.produto?.nome || '';
            return /INVERSOR/i.test(nome);
        });

        if (inversor && inversor.produto?.nome) {
            const nomeInversor = inversor.produto.nome;
            const quantidadeInversor = parseInt(inversor.quantidade) || 1;

            // Extrai marca do inversor (usando marcas mapeadas do backend)
            const marcaMatch = nomeInversor.match(/\b(DEYE|GROWATT|GOODWE|EACH|BELENERGY|SOLIS|SOFAR)\b/i);
            if (marcaMatch) {
                dadosReferencia.inversorMarca = marcaMatch[1].toUpperCase();
            }

            // Extrai potência (ex: "7,5kW", "10K", "7.5kW")
            const potenciaMatch = nomeInversor.match(/(\d+\.?\d*)[,.]?(\d*)\s*k?W?/i);
            if (potenciaMatch) {
                let potenciaUnitaria = parseFloat(potenciaMatch[1]);
                if (potenciaMatch[2]) {
                    potenciaUnitaria = parseFloat(`${potenciaMatch[1]}.${potenciaMatch[2]}`);
                }

                if (potenciaUnitaria && !isNaN(potenciaUnitaria)) {
                    const potenciaTotal = potenciaUnitaria * quantidadeInversor;
                    setValue('inversor', potenciaTotal);

                    dadosReferencia.inversorPotenciaUnitaria = potenciaUnitaria;
                    dadosReferencia.inversorQuantidade       = quantidadeInversor;
                    dadosReferencia.inversorPotenciaTotal    = potenciaTotal;
                }
            }

            // Extrai MPPTs (ex: "2MPPT", "3MPPT")
            const mpptMatch = nomeInversor.match(/(\d+)\s*MPPT/i);
            if (mpptMatch) {
                const mpptUnitario = parseInt(mpptMatch[1]);
                if (mpptUnitario && !isNaN(mpptUnitario)) {
                    // MPPT total = unitário × quantidade de inversores
                    const mpptTotal = mpptUnitario * quantidadeInversor;
                    setValue('mppt', mpptTotal);
                }
            }

            // Extrai voltagem (ex: "220V", "380V")
            const voltMatch = nomeInversor.match(/(\d+)\s*V\b/i);
            if (voltMatch) {
                const voltagem = parseInt(voltMatch[1]);
                if (voltagem && !isNaN(voltagem)) {
                    setValue('voltagem', voltagem);
                }
            }

            // Detecta tipo de ligação
            if (/TRI|TRIFASIC/i.test(nomeInversor)) {
                setValue('ligacao', 3);
                dadosReferencia.ligacao = 'TRI';
            } else if (/BI|BIFASIC/i.test(nomeInversor)) {
                setValue('ligacao', 2);
                dadosReferencia.ligacao = 'BI';
            } else if (/MONO|MONOFASIC/i.test(nomeInversor)) {
                setValue('ligacao', 1);
                dadosReferencia.ligacao = 'MONO';
            }
        }

        // Parser de Estrutura
        let estruturaId = allData.estrutura;
        const estruturaProd = produtos.find((p: any) => {
            const nome = p?.produto?.nome || '';
            return /ESTRUTURA|TELHA|LAJE|SOLO|COLONIAL|FIBROCIMENTO|ONDULADA|ZIPADA/i.test(nome);
        });

        if (estruturaProd && estruturaProd.produto?.nome) {
            const nomeEstrutura = estruturaProd.produto.nome;

            if (/METALICA/i.test(nomeEstrutura)) {
                const dimensaoMatch = nomeEstrutura.match(/(\d+\s*CM)/i);
                if (dimensaoMatch && dimensaoMatch[1].replace(/\s+/g, '').toUpperCase() === '55CM') {
                    estruturaId = 143;
                } else if (/ZIPADA/i.test(nomeEstrutura)) {
                    estruturaId = 296;
                } else {
                    estruturaId = 143;
                }
            } else if (/FIBROCIMENTO|ONDULADA/i.test(nomeEstrutura)) {
                estruturaId = 120;
            } else if (/LAJE/i.test(nomeEstrutura)) {
                estruturaId = 140;
            } else if (/SOLO/i.test(nomeEstrutura)) {
                estruturaId = 133;
            } else if (/COLONIAL/i.test(nomeEstrutura)) {
                estruturaId = 131;
            }

            setValue('estrutura', estruturaId);
        }

        // Parser de Cabos
        const cabo = produtos.find((p: any) => {
            const nome = p?.produto?.nome || '';
            return /CABO/i.test(nome);
        });

        if (cabo) {
            dadosReferencia.cabos = true;
        }

        // Gera referência automaticamente seguindo padrão exato
        const gerarReferencia = () => {
            const fmt = (n: number) => n % 1 === 0 ? n.toFixed(0) : n.toFixed(1);
            const partes = [];

            // 1. Fornecedor
            if (dadosReferencia.fornecedor) {
                partes.push(dadosReferencia.fornecedor);
            }

            // 2. Inversor: {potencia}K-{ligacao} ou {potencia}K-{ligacao}x{qty}={total}K se múltiplos
            if (dadosReferencia.inversorPotenciaUnitaria) {
                const pot    = fmt(dadosReferencia.inversorPotenciaUnitaria);
                const ligaca = dadosReferencia.ligacao || '';
                if (dadosReferencia.inversorQuantidade > 1) {
                    const total = fmt(dadosReferencia.inversorPotenciaTotal);
                    partes.push(`${pot}K-${ligaca}x${dadosReferencia.inversorQuantidade}=${total}K`);
                } else {
                    partes.push(ligaca ? `${pot}K-${ligaca}` : `${pot}K`);
                }
            }

            // 4. Marca do Inversor
            if (dadosReferencia.inversorMarca) {
                partes.push(dadosReferencia.inversorMarca);
            }

            // 5. Placas (quantidade x potência)
            if (dadosReferencia.placas) {
                partes.push(dadosReferencia.placas);
            }

            // 6. Tipo do Painel
            if (dadosReferencia.tipoPainel) {
                partes.push(dadosReferencia.tipoPainel);
            }

            // 7. Marca do Painel
            if (dadosReferencia.marcaPainel) {
                partes.push(dadosReferencia.marcaPainel);
            }

            // 8. Estrutura
            const estruturaRefMap: any = {
                131: 'COLONIAL', 120: 'FIBROCIMENTO', 143: 'METALICA-55CM',
                133: 'SOLO',     141: 'MADEIRA',      156: 'FERRO',
                140: 'LAJE',     296: 'METALICA-ZIPADA', 200: 'CARTPORT',
            };
            if (estruturaRefMap[estruturaId]) {
                partes.push(estruturaRefMap[estruturaId]);
            }

            // 10. Cabos
            if (dadosReferencia.cabos) {
                partes.push('CABOS');
            }

            return partes.filter(p => p).join('-');
        };

        const referenciaGerada = gerarReferencia();
        if (referenciaGerada) {
            setValue('referencia', referenciaGerada);
        }
    };

    return (
        <>
            <FormProvider {...methods} >
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <WindowBody>
                        <div className="row">
                            {/* COLUNA ESQUERDA - Produtos */}
                            <div className="col-lg-7">
                                <fieldset>
                                    <legend>Produtos do Kit</legend>
                                    <UiGridForm name="produtoList" label="" bare>
                                        <UiInputText size={2} name="quantidade" label="Qtd." />
                                        <UiInputText size={9} name="produto.nome" label="Nome do Produto" />
                                        <UiInputText size={1} name="produto.ordem" label="Ord." />
                                    </UiGridForm>
                                </fieldset>
                            </div>

                            {/* COLUNA DIREITA - Dados do Kit */}
                            <div className="col-lg-5">
                                <fieldset>
                                    <legend>Informações Básicas</legend>
                                    <div className="row">
                                        <UiInputSuggest size={12} router="fornecedor" idField="id" titleField="razaoSocial" name="fornecedor" label="Fornecedor" />
                                        <UiInputList size={4} name="estrutura" list={estruturaList} idField="id" titleField="title" label="Estrutura" />
                                        <UiInputText size={8} name="referencia" label="Referência" linkComponent={() => (
                                            <a className="link-element" href="#" onClick={(e) => { e.preventDefault(); detectarAutomaticamente(); }}>
                                                Detectar Automaticamente
                                            </a>
                                        )}/>
                                        <UiInputList size={3} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo" />
                                        <UiInputList size={5} name="ligacao" list={ligacaoList} idField="id" titleField="title" label="Ligação" />
                                        <UiInputCheckbox size={4} name="disponivel" label="Disponível"/>
                                    </div>
                                </fieldset>

                                <div className="row">
                                    <div className="col-6">
                                        <fieldset>
                                            <legend>Placas</legend>
                                            <div className="row">
                                                <UiInputNumber mode="decimal" size={12} name="numeroPlacas" label="Qtd. Placas"/>
                                                <UiInputNumber mode="decimal" size={12} name="potenciaPlacas" label="Potência (W)"/>
                                                <UiInputNumber mode="decimal" size={12} name="kwp" label="kWp" minFractionDigits={2} />
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div className="col-6">
                                        <fieldset>
                                            <legend>Inversor</legend>
                                            <div className="row">
                                                <UiInputNumber mode="decimal" size={12} name="inversor" label="Potência (kW)"/>
                                                <UiInputNumber mode="decimal" size={12} name="mppt" label="MPPTs"/>
                                                <UiInputNumber mode="decimal" size={12} name="voltagem" label="Voltagem (V)"/>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>

                                <fieldset>
                                    <legend>Dimensões e Custo</legend>
                                    <div className="row">
                                        <UiInputNumber mode="decimal" size={4} name="peso" label="Peso (kg)"/>
                                        <UiInputNumber mode="decimal" size={4} name="area" label="Área (m²)"/>
                                        <UiInputMoney size={4} name="preco" label="Preço (R$)"/>
                                    </div>
                                </fieldset>

                                <fieldset>
                                    <legend>Mídia e Documentação</legend>
                                    <div className="row">
                                        <UiInputText size={12} name="imagem" label="URL da Imagem"/>
                                        <UiInputText size={12} name="link" label="Link Externo"/>
                                    </div>
                                </fieldset>

                                <fieldset>
                                    <legend>Observação</legend>
                                    <div className="row">
                                        <UiInputTextarea size={12} name="observacao" label="Uso interno, não sai na impressão" rows={4}/>
                                    </div>
                                </fieldset>
                            </div>

                            {/*<pre>{JSON.stringify(allData, null, 2)}</pre>*/}
                        </div>

                    </WindowBody>

                    <WindowFooter>
                        <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                        <UiButton variant="primary" type="submit">Salvar</UiButton>
                        <UiButton variant="primary" onClick={() => { props.triggerSubmitAsNew(allData) }}>Salvar como novo</UiButton>
                    </WindowFooter>
                </Form>
            </FormProvider>
        </>
    )
}